
// import React, { useEffect, useState } from 'react'
// import CustomTable from '../../Components/Table/CustomTable';

// import { Grid } from '@mui/material';
// import AllUserListCreateModal from './Modal/AllUserListCreateModal';
// import TableDataViewModal from './Modal/TableDataViewModal';
// import ReferrerTableViewModal from './Modal/ReferrerTableViewModal';
// import actions from '../../ReduxStore/actions';
// import { useDispatch, useSelector } from 'react-redux';
// import { setHeaderName, setSubHeaderName } from '../../ReduxStore/Slices/headerSlice';

// const ReferrerList = () => {


//   const tableData = [
//     { PurchaserName: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "234324343432", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
//     { PurchaserName: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "4344343534", DiamondReferrals: "Bigil", RubyReferrals: "Surya" },
//     { PurchaserName: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "8987788876", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
//     { PurchaserName: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "678768688", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
//     { PurchaserName: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "896968676", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },



//   ];


//   const dispatch = useDispatch()
//   const { getAllCustomerRewardsListForAuthUser } = useSelector(
//     (state) => state?.getAllCustomerRewardsListForAuthUser
//   );

//   const [dynamicTierHeaderData, setDynamicTierHeader] = useState([])

//   console.log(getAllCustomerRewardsListForAuthUser, "getAllCustomerRewardsListForAuthUser");


//   useEffect(() => {
//     const data1 = {
//       data: {
//         // createdByUserId: sessionOperator_id,
//         // createdByUserRole: UserRole,
//       },
//       method: "get",
//       apiName: "getAllReferrerCustomerRewardsWithTiers",
//     };

//     dispatch(actions.GETALLCUSTOMERREWARDSLISTFORAUTHUSER(data1));
//   }, [dispatch]);

//   const [rowTableData, setRowTableData] = useState([
//     {
//       Name: "--",
//       CustomerId: "--",
//       Email: "--",
//       MobileNumber: "--",

//     },
//   ]);
//   console.log(rowTableData, "rowTableDatarowTableData");
//   useEffect(() => {

//     const fetchData = async () => {

//       const referrerCustomers = getAllCustomerRewardsListForAuthUser?.data?.Referrercustomers ?? [];
 
//       const dynamicHeading = await Array.from(
//         new Set(
//           referrerCustomers.flatMap((referrer) =>
//             Object.keys(referrer.rewardsByTier?? {})
//           )
//         )
//       )

//       setDynamicTierHeader(dynamicHeading)

//       console.log(dynamicHeading, "dynamicHeadingdynamicHeading");


//       // const dynamicDate = await 


//       const tempArr = [];
//       await getAllCustomerRewardsListForAuthUser?.data?.Referrercustomers?.map((data, index) => {
//         // Reduce dynamicHeading into key-value pairs
//         const tierRewards = dynamicHeading.reduce((acc, tier) => {
//           const rewards = data.rewardsByTier[tier];
//           acc[tier] = rewards && rewards.length > 0 ?  rewards
//               .map((reward) => `${reward.triggered_by.first_name} ${reward.triggered_by.last_name}`)
//               // how much name we want 
//               .slice(0, 2) 
//               .join(", ") + (rewards.length > 2 ? " ..." : ""): "--"

//           return acc;
//         }, {});

//         console.log(tierRewards,"tierRewardstierRewards");
        

//         return tempArr.push({
//           Name: `${data?.referrer_first_name} ${data?.referrer_last_name}`,
//           customer_id: data?.referrer_id,
//           Email: data?.referrer_email,
//           MobileNumber: data?.referrer_phone,
//           ...tierRewards, // Spread the dynamically created tier data
//         })
//       }
//       );
//       setRowTableData(tempArr);

//     }

//     fetchData()

//   }, [dispatch, getAllCustomerRewardsListForAuthUser])


//   React.useEffect(() => {
//     dispatch(setHeaderName("Operator Registration"));
//     dispatch(setSubHeaderName("Referrer List"));
//   }, [dispatch]);


//   const tableHeadData = ['S.No', 'Referrer Name', 'Referrer Id', "Email", "Mobile Number", ...dynamicTierHeaderData];
//   return (
//     <Grid container spacing={2}>

//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable tableData={rowTableData} title="Refferer List" tableHeadData={tableHeadData} dataCreate="dataCreate"
//           modalVeiwName={ReferrerTableViewModal}
//           modalHeadingName="Create User"
//           modalViewHeadingName="Referrer Detail"
//           tableEdit="tableEdit"
//           tableView="tableview"

//         />

//       </Grid>
//     </Grid>
//   )
// }

// export default ReferrerList



import React, { useEffect, useState } from 'react'
import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from '@mui/material';
import AllUserListCreateModal from './Modal/AllUserListCreateModal';
import TableDataViewModal from './Modal/TableDataViewModal';
import ReferrerTableViewModal from './Modal/ReferrerTableViewModal';
import actions from '../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../ReduxStore/Slices/headerSlice';

const ReferrerList = () => {


  const tableData = [
    { PurchaserName: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "234324343432", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
    { PurchaserName: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "4344343534", DiamondReferrals: "Bigil", RubyReferrals: "Surya" },
    { PurchaserName: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "8987788876", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
    { PurchaserName: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "678768688", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },
    { PurchaserName: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "896968676", DiamondReferrals: "Biddu", RubyReferrals: "Raj" },



  ];


  const dispatch = useDispatch()
  const { getAllCustomerRewardsListForAuthUser } = useSelector(
    (state) => state?.getAllCustomerRewardsListForAuthUser
  );

  const [dynamicTierHeaderData, setDynamicTierHeader] = useState([])

  console.log(getAllCustomerRewardsListForAuthUser, "getAllCustomerRewardsListForAuthUser");


  useEffect(() => {

    const data1 = {
      data: {
        // createdByUserId: sessionOperator_id,
        // createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getAllReferrerCustomerRewardsWithTiers",
    };

    dispatch(actions.GETALLCUSTOMERREWARDSLISTFORAUTHUSER(data1));
  }, [dispatch]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      CustomerId: "--",
      Email: "--",
      MobileNumber: "--",

    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {

    const fetchData = async () => {

      const referrerCustomers = getAllCustomerRewardsListForAuthUser?.data?.Referrercustomers ?? [];

      const dynamicHeading = await Array.from(
        new Set(
          referrerCustomers.flatMap((referrer) =>
            Object.keys(referrer.rewardsByTier ?? {})
          )
        )
      )

      setDynamicTierHeader(dynamicHeading)

      console.log(dynamicHeading, "dynamicHeadingdynamicHeading");


      // const dynamicDate = await 


      const tempArr = [];
      await getAllCustomerRewardsListForAuthUser?.data?.Referrercustomers?.map((data, index) => {
        // Reduce dynamicHeading into key-value pairs
        const tierRewards = dynamicHeading.reduce((acc, tier) => {
          const rewards = data.rewardsByTier[tier];
          acc[tier] = rewards && rewards.length > 0 ? rewards
            .map((reward) => `${reward.triggered_by.first_name} ${reward.triggered_by.last_name}`)
            // how much name we want 
            .slice(0, 2)
            .join(", ") + (rewards.length > 2 ? " ..." : "") : "--"

          return acc;
        }, {});

        console.log(tierRewards, "tierRewardstierRewards");


        return tempArr.push({
          Name: `${data?.referrer_first_name} ${data?.referrer_last_name}`,
          customer_id: data?.referrer_id,
          Email: data?.referrer_email,
          MobileNumber: data?.referrer_phone,
          ...tierRewards, // Spread the dynamically created tier data
        })
      }
      );
      setRowTableData(tempArr);

    }

    fetchData()

  }, [dispatch, getAllCustomerRewardsListForAuthUser])


  React.useEffect(() => {
    dispatch(setHeaderName("Operator Registration"));
    dispatch(setSubHeaderName("Referrer List"));
  }, [dispatch]);


  const tableHeadData = ['S.No', 'Referrer Name',"Email Id", "Mobile Number", ...dynamicTierHeaderData];
  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable tableData={rowTableData} title="Refferer List" tableHeadData={tableHeadData} 
        // dataCreate="dataCreate"
          modalVeiwName={ReferrerTableViewModal}
          modalHeadingName="Create User"
          modalViewHeadingName="Referrer Detail"
          tableEdit="tableEdit"
          tableView="tableview"

        />

      </Grid>
    </Grid>
  )
}

export default ReferrerList